module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/feature_03-5e236ea373d32293bc1454a7e30492a3.png";